angular.module('SpidApp')

.factory('BusinessDaySyncService', ['$http', 'SyncConfig', 'Chunker', '$q', function ($http, SyncConfig, Chunker, $q) {
  var nodeUrl = SyncConfig.Node.getURLFor('/business-days')
  var nodeAuthorization = SyncConfig.Node.Authorization
  
  var distantUrl = SyncConfig.Distant.getURLFor('/businessdays')
  var distantAuthorization = SyncConfig.Distant.Authorization

  var BusinessDaySyncService = {
    Node: {
      getAllUnsync: function (lastSyncIsoDate) {
        if (!lastSyncIsoDate) {
          throw 'BusinessDaySyncService::Node::getAllUnsync() - Missing parameters'
        }

        var req = { method: 'GET', url: nodeUrl, headers: { 'Authorization': nodeAuthorization } }
        
        return $http(req).then(function (response) {
          return response.data
        }).then(function (businessDays) {
          return _.filter(businessDays, function (businessDay) {
            return moment(businessDay.updated_at).isAfter(moment(lastSyncIsoDate), 'second') // TODO
          })
        })
      }
    },
    Distant: {
      pushAll: function (businessDays) {
          var chunked = Chunker.inConstantSizeChunks(businessDays, SyncConfig.config.chunkLength)
          var p = $q(function (r) {r()})

          var pool = []
          for(var i = 0 ; i < chunked.length ; i++) {
              var data = chunked[i]
              var req = { method: 'POST', url: distantUrl, headers: { 'Authorization': distantAuthorization }, data: data }
              pool.push($http(req))
          }

          return p.then(function () {
              return $q.all(pool)
          }).then(function () {
              return {generic: 'OK'}
          })
      }
    }
  }

  return BusinessDaySyncService
}])